import { ChangeEvent, useState } from 'react';
import {
  MenuItem,
  SxProps,
  TextField,
  Typography,
  Chip,
  Box,
} from '@mui/material';

type DropdownProps = {
  defaultValue?: string;
  label?: string;
  sx?: SxProps;
  options: Record<string, string>;
  onChange: (value: string) => void;
  preferred?: string;
  disabledOptions?: string[];
  [x: string]: any;
};

const renderValueHandler = (
  value: string,
  options: Record<string, string>,
  preferred?: string
): string | JSX.Element => {
  if (preferred !== value) return options[value];
  return (
    <Box display="flex" flexDirection="row" gap={2} alignItems="center">
      <Typography>{`${options[value]}`}</Typography>
      <Chip
        label="Most common"
        sx={{ backgroundColor: 'yellow.lightest', height: '24px' }}
      />
    </Box>
  );
};

export const Dropdown = ({
  defaultValue = '',
  label = '',
  sx,
  onChange,
  options,
  preferred,
  disabledOptions = [],
  ...rest
}: DropdownProps): JSX.Element => {
  const [value, setValue] = useState(defaultValue);

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const {
      target: { value },
    } = event;
    setValue(value);
    onChange(value);
  };
  return (
    <TextField
      defaultValue={defaultValue}
      label={label}
      value={value}
      onChange={handleChange}
      select
      sx={{
        minWidth: '200px',
        width: '100%',
        '& .MuiOutlinedInput-root': {
          '& fieldset': { borderColor: 'neutral.lighter' },
        },
        ...sx,
      }}
      variant="outlined"
      SelectProps={{
        renderValue: (value) =>
          renderValueHandler(value as string, options, preferred),
      }}
      {...rest}
    >
      {Object.entries(options).map(([key, val]) => (
        <MenuItem
          key={key}
          value={key}
          disabled={disabledOptions.includes(key) && key !== value}
        >
          {val}
        </MenuItem>
      ))}
    </TextField>
  );
};
